/**
 * Event data registry
 * Add new event data files here to make them available in the inserter
 */

import { LegacyRegistrationRecord } from './WSGIBAAnnualNetworkingLuncheon2025';
import { WSGMAGroupNetworking2025Records, WSGMAGroupNetworking2025UpdateRecords } from './WSGMAGroupNetworking2025';
import { WSGIBAAnnualNetworkingLuncheon2025Records, WSGIBAAnnualNetworkingLuncheon2025UpdateRecords } from './WSGIBAAnnualNetworkingLuncheon2025';
import { WSGAPACRegionalMeeting2025Records, WSGAPACRegionalMeeting2025UpdateRecords } from './WSGAPACRegionalMeeting2025';
import { WSGAutomotiveGroupMeeting2025EuropeRecords, WSGAutomotiveGroupMeeting2025EuropeUpdateRecords } from './WSGAutomotiveGroupMeeting2025Europe';
import { WSGPatentLawGroupMeeting2025EuropeRecords, WSGPatentLawGroupMeeting2025EuropeUpdateRecords } from './WSGPatentLawGroupMeeting2025Europe';
import { WSGEmploymentAndLaborGroupMeeting2025EuropeRecords, WSGEmploymentAndLaborGroupMeeting2025EuropeUpdateRecords } from './WSGEmploymentAndLaborGroupMeeting2025Europe';
import { WSGEnergyGroupMeeting2025EuropeRecords, WSGEnergyGroupMeeting2025EuropeUpdateRecords } from './WSGEnergyGroupMeeting2025Europe';
import { WSGESGGroupMeeting2025EuropeRecords, WSGESGGroupMeeting2025EuropeUpdateRecords } from './WSGESGGroupMeeting2025Europe';
import { WSGTMTGroupMeeting2025EuropeRecords, WSGTMTGroupMeeting2025EuropeUpdateRecords } from './WSGTMTGroupMeeting2025Europe';
import { WSGAnnualMeeting2025Records, WSGAnnualMeeting2025UpdateRecords } from './WSGAnnualMeeting2025';
import { MarketplaceChaosToControl2025Records } from './MarketplaceChaosToControl2025';
import { WSGBankingFinanceGroupMeeting2025EuropeRecords, WSGBankingFinanceGroupMeeting2025EuropeUpdateRecords } from './WSGBankingFinanceGroupMeeting2025Europe';
import { WSGBankingFinanceGroupMeeting2026EuropeRecords } from './WSGBankingFinanceGroupMeeting2026Europe';
import { WSGINTACocktail2025Records } from './WSGINTACocktail2025';
import { WSGAmericasMeeting2025Records, WSGAmericasMeeting2025UpdateRecords } from './WSGAmericasMeeting2025';
import { WSGIBAEuropeanMALuncheon2025Records, WSGIBAEuropeanMALuncheon2025UpdateRecords } from './WSGIBAEuropeanMALuncheon2025';
import { WSGEuropeanMeeting2025Records, WSGEuropeanMeeting2025UpdateRecords } from './WSGEuropeanMeeting2025';
import { WSGAPACMeeting2026Records } from './WSGAPACMeeting2026';
import { WSGEuropeanRegionalMeeting2026Records } from './WSGEuropeanRegionalMeeting2026';
import { WSGAmericasRegionalMeeting2026Records } from './WSGAmericasRegionalMeeting2026';
import { WSGAnnualMeeting2026Records } from './WSGAnnualMeeting2026';

export interface EventData {
  id: string;
  name: string;
  records: LegacyRegistrationRecord[];
}

export const EVENT_DATA_REGISTRY: EventData[] = [
  {
    id: 'wsg-ma-group-networking-2025',
    name: 'WSG M&A Group Networking 2025',
    records: WSGMAGroupNetworking2025Records,
  },
  {
    id: 'wsg-ma-group-networking-2025-updates',
    name: 'WSG M&A Group Networking 2025 - Payment Updates',
    records: WSGMAGroupNetworking2025UpdateRecords as LegacyRegistrationRecord[],
  },
  {
    id: 'wsg-iba-annual-networking-luncheon-2025',
    name: 'WSG IBA Annual Networking Luncheon 2025',
    records: WSGIBAAnnualNetworkingLuncheon2025Records,
  },
  {
    id: 'wsg-iba-annual-networking-luncheon-2025-updates',
    name: 'WSG IBA Networking Luncheon 2025 - Payment Updates',
    records: WSGIBAAnnualNetworkingLuncheon2025UpdateRecords as LegacyRegistrationRecord[],
  },
  {
    id: 'wsg-apac-regional-meeting-2025',
    name: 'WSG APAC Regional Meeting 2025',
    records: WSGAPACRegionalMeeting2025Records,
  },
  {
    id: 'wsg-apac-regional-meeting-2025-updates',
    name: 'WSG APAC Regional Meeting 2025 - Payment Updates',
    records: WSGAPACRegionalMeeting2025UpdateRecords as LegacyRegistrationRecord[],
  },
  {
    id: 'wsg-automotive-group-meeting-2025-europe',
    name: 'WSG Automotive Group Meeting 2025 - Europe',
    records: WSGAutomotiveGroupMeeting2025EuropeRecords,
  },
  {
    id: 'wsg-automotive-group-meeting-2025-europe-updates',
    name: 'WSG Automotive Group Meeting 2025 - Europe - Payment Updates',
    records: WSGAutomotiveGroupMeeting2025EuropeUpdateRecords as LegacyRegistrationRecord[],
  },
  {
    id: 'wsg-patent-law-group-meeting-2025-europe',
    name: 'WSG Patent Law Group Meeting 2025 - Europe',
    records: WSGPatentLawGroupMeeting2025EuropeRecords,
  },
  {
    id: 'wsg-patent-law-group-meeting-2025-europe-updates',
    name: 'WSG Patent Law Group Meeting 2025 - Europe - Payment Updates',
    records: WSGPatentLawGroupMeeting2025EuropeUpdateRecords as LegacyRegistrationRecord[],
  },
  {
    id: 'wsg-employment-and-labor-group-meeting-2025-europe',
    name: 'WSG Employment and Labor Group Meeting 2025 - Europe',
    records: WSGEmploymentAndLaborGroupMeeting2025EuropeRecords,
  },
  {
    id: 'wsg-employment-and-labor-group-meeting-2025-europe-updates',
    name: 'WSG Employment and Labor Group Meeting 2025 - Europe - Payment Updates',
    records: WSGEmploymentAndLaborGroupMeeting2025EuropeUpdateRecords as LegacyRegistrationRecord[],
  },
  {
    id: 'wsg-energy-group-meeting-2025-europe',
    name: 'WSG Energy Group Meeting 2025 - Europe',
    records: WSGEnergyGroupMeeting2025EuropeRecords,
  },
  {
    id: 'wsg-energy-group-meeting-2025-europe-updates',
    name: 'WSG Energy Group Meeting 2025 - Europe - Payment Updates',
    records: WSGEnergyGroupMeeting2025EuropeUpdateRecords as LegacyRegistrationRecord[],
  },
  {
    id: 'wsg-esg-group-meeting-2025-europe',
    name: 'WSG ESG Group Meeting 2025 - Europe',
    records: WSGESGGroupMeeting2025EuropeRecords,
  },
  {
    id: 'wsg-esg-group-meeting-2025-europe-updates',
    name: 'WSG ESG Group Meeting 2025 - Europe - Payment Updates',
    records: WSGESGGroupMeeting2025EuropeUpdateRecords as LegacyRegistrationRecord[],
  },
  {
    id: 'wsg-tmt-group-meeting-2025-europe',
    name: 'WSG TMT Group Meeting 2025 - Europe',
    records: WSGTMTGroupMeeting2025EuropeRecords,
  },
  {
    id: 'wsg-tmt-group-meeting-2025-europe-updates',
    name: 'WSG TMT Group Meeting 2025 - Europe - Payment Updates',
    records: WSGTMTGroupMeeting2025EuropeUpdateRecords as LegacyRegistrationRecord[],
  },
  {
    id: 'wsg-annual-meeting-2025',
    name: 'WSG Annual Meeting 2025',
    records: WSGAnnualMeeting2025Records,
  },
  {
    id: 'wsg-annual-meeting-2025-updates',
    name: 'WSG Annual Meeting 2025 - Payment Updates',
    records: WSGAnnualMeeting2025UpdateRecords as LegacyRegistrationRecord[],
  },
  {
    id: 'marketplace-chaos-to-control-2025',
    name: 'From Marketplace Chaos to Control: Strategic Brand Protection in the eCommerce Era',
    records: MarketplaceChaosToControl2025Records,
  },
  {
    id: 'wsg-banking-finance-group-meeting-2025-europe',
    name: 'WSG Banking & Finance Group Meeting 2025 - Europe',
    records: WSGBankingFinanceGroupMeeting2025EuropeRecords,
  },
  {
    id: 'wsg-banking-finance-group-meeting-2025-europe-updates',
    name: 'WSG Banking & Finance Group Meeting 2025 - Europe - Payment Updates',
    records: WSGBankingFinanceGroupMeeting2025EuropeUpdateRecords as LegacyRegistrationRecord[],
  },
  {
    id: 'wsg-inta-cocktail-2025',
    name: 'WSG INTA Cocktail 2025',
    records: WSGINTACocktail2025Records,
  },
  {
    id: 'wsg-americas-meeting-2025',
    name: 'WSG Americas Meeting 2025',
    records: WSGAmericasMeeting2025Records,
  },
  {
    id: 'wsg-americas-meeting-2025-updates',
    name: 'WSG Americas Meeting 2025 - Payment Updates',
    records: WSGAmericasMeeting2025UpdateRecords as LegacyRegistrationRecord[],
  },
  {
    id: 'wsg-iba-european-ma-luncheon-2025',
    name: 'WSG IBA European M&A Luncheon 2025',
    records: WSGIBAEuropeanMALuncheon2025Records,
  },
  {
    id: 'wsg-iba-european-ma-luncheon-2025-updates',
    name: 'WSG IBA European M&A Luncheon 2025 - Payment / Cancelled / Sponsor Updates',
    records: WSGIBAEuropeanMALuncheon2025UpdateRecords as LegacyRegistrationRecord[],
  },
  {
    id: 'wsg-european-meeting-2025',
    name: 'WSG European Meeting 2025',
    records: WSGEuropeanMeeting2025Records,
  },
  {
    id: 'wsg-european-meeting-2025-updates',
    name: 'WSG European Meeting 2025 - Payment Updates',
    records: WSGEuropeanMeeting2025UpdateRecords as LegacyRegistrationRecord[],
  },
  {
    id: 'wsg-banking-finance-group-meeting-2026-europe',
    name: 'WSG Banking & Finance Group Meeting 2026 - Europe',
    records: WSGBankingFinanceGroupMeeting2026EuropeRecords,
  },
  {
    id: 'wsg-apac-meeting-2026',
    name: 'WSG APAC Meeting 2026',
    records: WSGAPACMeeting2026Records,
  },
  {
    id: 'wsg-european-regional-meeting-2026',
    name: 'WSG European Regional Meeting 2026',
    records: WSGEuropeanRegionalMeeting2026Records,
  },
  {
    id: 'wsg-americas-regional-meeting-2026',
    name: 'WSG Americas Regional Meeting 2026',
    records: WSGAmericasRegionalMeeting2026Records,
  },
  {
    id: 'wsg-annual-meeting-2026',
    name: 'WSG Annual Meeting 2026',
    records: WSGAnnualMeeting2026Records,
  },
];


